import type { ReactNode } from "react";

type EmptyStateProps = {
  readonly actions?: ReactNode;
  readonly description: string;
  readonly icon?: ReactNode;
  readonly title: string;
};

export function EmptyState({
  actions,
  description,
  icon = "0",
  title,
}: EmptyStateProps) {
  return (
    <div className="rounded-panel border border-border bg-surface px-6 py-14 text-center text-ink-muted">
      <div className="mx-auto mb-4 flex h-[60px] w-[60px] items-center justify-center rounded-dialog border border-border bg-panel-muted text-2xl text-ink-subtle">
        {icon}
      </div>
      <h3 className="mb-1.5 text-[17px] font-semibold text-ink">{title}</h3>
      <p className="mx-auto mb-4 max-w-sm text-[13px]">{description}</p>
      {actions ? (
        <div className="flex justify-center gap-2">{actions}</div>
      ) : null}
    </div>
  );
}
